import type { ProFormColumnsType } from '@ant-design/pro-components';
import type { ExistingFirmResponse } from 'api/firm/firm.types';
import { introducerQuestions } from 'pages/ApplicationFormPage/Introducer/questions';
import type { TypedFormatMessageFn } from 'types/intl';
import { EMAIL_REGEXP } from '../../../common/regexp';
import { gbPhoneNumberAntdRule } from 'utils/gbPhoneNumber';
import { isStrideUpInternalFirm } from 'utils/strideUpInternalFirm';

interface IntroducerFormSchemaProps {
  formatMessage: TypedFormatMessageFn;
  firm?: ExistingFirmResponse | null;
}

export function introducerFormSchema(props: IntroducerFormSchemaProps): ProFormColumnsType[] {
  if (!props.firm || !isStrideUpInternalFirm(props.firm)) {
    return [];
  }

  const requiredFieldMessage = props.formatMessage({ id: 'common.error.requiredField' });

  return [
    {
      title: props.formatMessage({ id: introducerQuestions.hasIntroducer.labelKey }),
      dataIndex: 'hasIntroducer',
      valueType: 'radioButton',
      fieldProps: {
        options: [
          { label: props.formatMessage({ id: 'common.yes' }), value: 'true' },
          { label: props.formatMessage({ id: 'common.no' }), value: 'false' },
        ],
        buttonStyle: 'solid',
      },
      formItemProps: {
        rules: [{ message: requiredFieldMessage, required: true }],
      },
    },
    {
      valueType: 'dependency',
      name: ['hasIntroducer'],
      columns: ({ hasIntroducer }) => {
        if (hasIntroducer !== 'true') {
          return [];
        }

        return [
          {
            title: props.formatMessage({ id: introducerQuestions.firstName.labelKey }),
            dataIndex: 'introducerFirstName',
            formItemProps: {
              rules: [{ message: requiredFieldMessage, required: true }],
            },
          },
          {
            title: props.formatMessage({ id: introducerQuestions.lastName.labelKey }),
            dataIndex: 'introducerLastName',
            formItemProps: {
              rules: [{ message: requiredFieldMessage, required: true }],
            },
          },
          {
            title: props.formatMessage({ id: introducerQuestions.email.labelKey }),
            dataIndex: 'introducerEmail',
            formItemProps: {
              rules: [
                { message: requiredFieldMessage, required: true },
                {
                  pattern: EMAIL_REGEXP,
                  message: props.formatMessage({ id: 'common.error.validEmail' }),
                },
              ],
            },
          },
          {
            title: props.formatMessage({ id: introducerQuestions.phoneNumber.labelKey }),
            dataIndex: 'introducerPhoneNumber',
            formItemProps: {
              rules: [
                gbPhoneNumberAntdRule(props.formatMessage({ id: 'common.error.validPhoneNumber' })),
                { message: requiredFieldMessage, required: true },
              ],
            },
          },
        ];
      },
    },
  ];
}
